export { scrollTo, ScrollToOptions } from './scroll-to';
